import { useEffect, useMemo, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import {
  formatDateRu,
  formatTimeRu,
  toDateInputValue,
} from "../../../utils/appointmentLabels";
import s from "../clinic.module.css";
import { Button, Field, Input, Modal, useToast } from "../../ui";

export default function PatientRescheduleModal({
  appointment,
  open,
  onClose,
  onDone,
}) {
  const toast = useToast();
  const [date, setDate] = useState(toDateInputValue());
  const [slots, setSlots] = useState([]);
  const [slotIso, setSlotIso] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !appointment) return;
    setDate(toDateInputValue(new Date(appointment.start_datetime)));
    setSlotIso("");
  }, [open, appointment]);

  useEffect(() => {
    if (!open || !appointment?.doctor_id || !appointment?.branch_id) return;
    setLoading(true);
    clinicAPI
      .getSlots(
        appointment.doctor_id,
        appointment.branch_id,
        date,
        appointment.service_id,
      )
      .then((r) => setSlots(r.slots || []))
      .catch(() => setSlots([]))
      .finally(() => setLoading(false));
  }, [open, appointment, date]);

  const dates = useMemo(() => {
    const list = [];
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    for (let i = 0; i < 14; i++) {
      const x = new Date(d);
      x.setDate(d.getDate() + i);
      list.push(toDateInputValue(x));
    }
    return list;
  }, []);

  const submit = async () => {
    if (!slotIso) {
      toast.error("Выберите время");
      return;
    }
    setSaving(true);
    try {
      await clinicAPI.rescheduleAppointment(appointment.id, {
        start_datetime: slotIso,
      });
      toast.success("Запись перенесена");
      onDone?.();
      onClose?.();
    } catch (e) {
      toast.error(e.response?.data?.error || "Не удалось перенести");
    } finally {
      setSaving(false);
    }
  };

  if (!appointment) return null;

  return (
    <Modal open={open} onClose={onClose} title="Перенести запись">
      <p className={s.modalBodyText}>
        {appointment.doctor?.full_name} · {appointment.service?.name}
      </p>
      <Field label="Дата">
        <div className={s.portalDateChips}>
          {dates.map((d) => (
            <button
              key={d}
              type="button"
              className={`${s.catalogChip} ${date === d ? s.catalogChipActive : ""}`}
              onClick={() => {
                setDate(d);
                setSlotIso("");
              }}
            >
              {formatDateRu(`${d}T12:00:00`, { day: "numeric", month: "short" })}
            </button>
          ))}
        </div>
      </Field>
      {loading ? (
        <p className={s.timelineLoading}>Загрузка слотов…</p>
      ) : slots.length === 0 ? (
        <p className={s.empty}>Нет свободного времени на эту дату</p>
      ) : (
        <div className={s.timeGrid}>
          {slots.map((sl) => {
            const iso =
              typeof sl === "string" ? sl : sl.start_datetime;
            return (
              <button
                key={iso}
                type="button"
                className={`${s.timeSlot} ${
                  slotIso === iso ? s.timeSlotSelected : ""
                }`}
                onClick={() => setSlotIso(iso)}
              >
                {formatTimeRu(iso)}
              </button>
            );
          })}
        </div>
      )}
      <div className={s.portalModalActions}>
        <Button variant="secondary" onClick={onClose}>
          Отмена
        </Button>
        <Button onClick={submit} disabled={saving || !slotIso}>
          {saving ? "Сохранение…" : "Перенести"}
        </Button>
      </div>
    </Modal>
  );
}
